<template>
  <div>
    <v-dialog v-model="dialog" max-width="900px">
      <v-btn color="btnColor" dark slot="activator" class="mb-2" flat>
        <v-icon>add</v-icon>Update Location
      </v-btn>
      <v-card>
        <v-toolbar color="green darken-1" flat dense dark>
          <v-toolbar-title class="title">Add Job Location</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn class="mx-0" icon @click="close">
            <v-icon color="white">clear</v-icon>
          </v-btn>
        </v-toolbar>
        
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <div class="location-div">
                  <span>Selected Location:</span>
                  <span class="location-text">{{ place.formatted_address}}</span>
                </div>
              </v-flex>
              <v-flex xs12 sm6 class="mapInput">
                <h2>Search a Location</h2>
                <label>
                  <gmap-autocomplete @place_changed="setPlace" :options="{fields: ['geometry', 'formatted_address', 'address_components']}"></gmap-autocomplete>
                  <!-- <v-btn @click="addMarker" flat color="btnColor">Add</v-btn> -->
                </label>
              </v-flex>

              <v-flex xs12 sm6>
                <v-btn small color="red" dark @click="reset">Reset Location</v-btn>
                <v-btn
                  color="btnColor"
                  class="right"
                  dark
                  small
                  @click="addLocation()"
                  :loading="loader"
                >
                  <v-icon left>add</v-icon>Save
                </v-btn>
              </v-flex>

              <v-flex xs12>
                <gmap-map :center="center" :zoom="12" style="width:100%;  height: 400px;">
                  <gmap-marker
                    :key="index"
                    v-for="(m, index) in markers"
                    :position="m.position"
                    @click="center=m.position"
                  ></gmap-marker>
                </gmap-map>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="errorSnackbar" :timeout="timeout" top right color="red">{{ errorText }}</v-snackbar>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
export default {
  name: "JobLocationModal",
  computed: {
    ...mapGetters(["user"])
  },
  components: {},
  data() {
    return {
      dialog: false,
      location: null,
      loader: false,
      errorSnackbar: false,
      timeout: 4000,
      errorText: "Please select a location",
      center: { lat: 45.508, lng: -73.587 },
      markers: [],
      place: {},
      currentPlace: null
    };
  },
  mounted() {
    this.geolocate();
  },
  methods: {
    // google maps
    setPlace(place) {
      this.currentPlace = place;
      this.addMarker();
    },
    reset() {
      this.place = {};
      this.markers = [];
    },
    addMarker() {
      if (this.currentPlace) {
        const marker = {
          lat: this.currentPlace.geometry.location.lat(),
          lng: this.currentPlace.geometry.location.lng()
        };
        this.markers.push({ position: marker });
        this.place = this.currentPlace;
        this.center = marker;
        this.currentPlace = null;
      }
    },
    geolocate: function() {
      navigator.geolocation.getCurrentPosition(position => {});
    },
    // end of google maps
    addLocation() {
      const lat = this.place.geometry.location.lat();
      const lng = this.place.geometry.location.lng();
      const coordinates = [];
      coordinates.push(lat);
      coordinates.push(lng);
      const locationObject = {
        type: "Point",
        coordinates: coordinates,
        locationName: this.place.formatted_address
      };
      const details = {
        location: locationObject
      }
      console.log(details, 'details');
      this.$emit("data", details);
      this.dialog = false;
    },
    close() {
      this.dialog = false;
    }
  }
};
</script>


<style scoped>
.mapInput input {
  border: 2px solid #a9a9a9;
  width: 350px;
}

.location-div {
  font-size: 20px;
}

.location-text {
  color: red;
}
</style>
